import React, { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CDN_TYPE_CRM, imageUrlCDN } from 'utils';

import { SiteConfigManager, useSettings } from '@atlas/core';
import { casinoRoutes, COMPONENT_TYPES } from '@atlas/routing';
import { FreeSpinCard as FreeSpinCardComponent } from '@atlas/ui';

import FreeSpinDetails from './FreeSpinDetails';
import { ACTIVATED } from './FreeSpins';

const { CASINO } = COMPONENT_TYPES;

const FreeSpinCard = ({ freeSpin }) => {
  const {
    freeSpin: { casinoLimit, localizedImageInfoList, localizedInfoList },
    status,
  } = freeSpin;
  const { push: historyPush } = useHistory();
  const { lang } = useSettings();

  const [openDetails, setOpenDetails] = useState(false);
  const casinoPath = SiteConfigManager.getComponentPath(CASINO, 'casino');
  const linkToGame = `${casinoPath}/${casinoRoutes.game}/${casinoLimit.gameIds[0]}`;

  const localizedInfoByLang = useMemo(
    () => localizedInfoList.find(info => info.language === lang) || localizedInfoList[0],
    [lang, localizedInfoList],
  );
  const imageUrl = useMemo(() => {
    if (localizedImageInfoList?.length) {
      const localizedImageInfoByLang =
        localizedImageInfoList.find(info => info.language === lang) || localizedImageInfoList[0];

      return imageUrlCDN(localizedImageInfoByLang.imageLink, CDN_TYPE_CRM);
    }

    return '';
  }, [lang, localizedImageInfoList]);

  const handleButtonClick = useCallback(
    e => {
      e.stopPropagation();

      historyPush(linkToGame);
    },
    [historyPush, linkToGame],
  );

  const handleCloseDetails = useCallback(e => {
    e.stopPropagation();

    setOpenDetails(false);
  }, []);

  return (
    <div className="freespin-card-wrapper" onClick={() => setOpenDetails(true)} role="button">
      <FreeSpinCardComponent
        activated={status === ACTIVATED}
        handleButtonClick={handleButtonClick}
        imageUrl={imageUrl}
        name={localizedInfoByLang.name}
        status={status}
      />
      {openDetails && (
        <FreeSpinDetails
          freeSpin={freeSpin}
          handleCloseDetails={handleCloseDetails}
          imageUrl={imageUrl}
          linkToGame={linkToGame}
          localizedInfoByLang={localizedInfoByLang}
        />
      )}
    </div>
  );
};

PropTypes.FreeSpinCard = {
  freeSpin: PropTypes.shape({
    freeSpin: PropTypes.shape({
      casinoLimit: PropTypes.shape({
        gameIds: PropTypes.arrayOf(PropTypes.string),
      }),
      localizedImageInfoList: PropTypes.arrayOf(
        PropTypes.shape({
          imageLink: PropTypes.string,
        }),
      ),
      name: PropTypes.string,
    }),
    status: PropTypes.string,
  }).isRequired,
};

export default FreeSpinCard;
